export default "__VITE_PUBLIC_ASSET__936e376f__"